import { zhCN } from './locales/zh-CN';
import type { LanguagePack } from './types';

/** 所有可用语言包的注册表；新增语言时只需在这里注册新的 pack。 */
export const languagePacks: Record<string, LanguagePack> = {
  [zhCN.locale]: zhCN,
};
